import React from 'react';
import { ShowAt } from 'consts/breakpoints';
import {
  PricesAccordionTab,
  PricesTabType,
} from 'store/state/selectors/insights/prices';
import HistoryTable from './tables/history';
import { PaginationType } from 'ds/components/pagination';

interface PricesTableProps {
  tab: PricesAccordionTab;
  visibleRowsMobile: number;
  visibleRowsDesktop: number;
  projectId?: string;
  projectIds?: string[];
  isProjectPage?: boolean;
  paginationType?: PaginationType;
}

const PricesTable: React.FC<PricesTableProps> = ({
  children,
  visibleRowsMobile,
  visibleRowsDesktop,
  tab,
  projectId,
  projectIds,
  paginationType,
}) => {
  return (
    <ShowAt at={1}>
      {matches => {
        switch (tab.tabId) {
          case PricesTabType.Unit:
          case PricesTabType.Building:
          case PricesTabType.Area:
          case PricesTabType.Compare:
          case PricesTabType.Street:
          case PricesTabType.CompareDeals:
            return (
              <HistoryTable
                isMobile={matches}
                tab={tab}
                visibleRowsMobile={visibleRowsMobile}
                visibleRowsDesktop={visibleRowsDesktop}
                paginationType={paginationType}
                projectId={projectId}
                projectIds={projectIds}
              >
                {children}
              </HistoryTable>
            );
          default:
            return null;
        }
      }}
    </ShowAt>
  );
};

export default PricesTable;
